import { inject, Injectable } from '@angular/core';
import { IPxlNotificationItem, LoginState } from '@pxl/models/common';
import { LoginService, NotificationService } from '@pxl/models/contracts';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class DefaultNotificationService implements NotificationService {
    public readonly onNotifications$: Observable<IPxlNotificationItem[]>;
    private readonly onUserLoginChanged$ = inject(LoginService).onUserLoginChanged();

    private readonly notificationSource$ = new BehaviorSubject<IPxlNotificationItem[]>([]);

    public constructor() {
        this.onNotifications$ = this.notificationSource$.asObservable();
        this.onUserLoginChanged$.subscribe((loginState: LoginState) => {
            if (!loginState.isLoggedIn || !loginState.isTermsOfUseForUserValid) {
                this.removeAllInAppNotifications();
            }
        });
    }

    public showNotification(notification: IPxlNotificationItem): void {
        this.notificationSource$.next([...this.notificationSource$.value, notification]);
    }

    public removeNotification(notificationId: string): void {
        const index = this.notificationSource$.value.findIndex((n) => n.pushNotificationSchema.id === notificationId);
        if (index > -1) {
            this.notificationSource$.value.splice(index, 1);
            this.notificationSource$.next(this.notificationSource$.value);
        }
    }

    public removeAllInAppNotifications(): void {
        this.notificationSource$.value.splice(0, this.notificationSource$.value.length);
        this.notificationSource$.next(this.notificationSource$.value);
    }
}
